import { CheckCircle } from "@phosphor-icons/react";
import { Reveal, ChapterTag } from "./Reveal";

const SECURITY_IMG =
  "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbmV0d29yayUyMHNlY3VyaXR5JTIwZGFya3xlbnwwfHx8fDE3ODc1NzQxMDF8MA&ixlib=rb-4.1.0&q=85";

const POINTS = [
  "Security-first processing for every deposit and withdrawal",
  "Transparent rates — you always confirm the rate before exchanging",
  "A simple, guided exchange flow from deposit to INR payout",
  "A dedicated support team when you need a hand",
];

export default function TrustSection() {
  return (
    <section id="security" data-testid="trust-section" className="relative border-t border-white/5 py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10">
            <img
              src={SECURITY_IMG}
              alt="Secure blockchain transaction network"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover sm:aspect-square"
              data-testid="trust-visual"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 rounded-2xl border border-white/10 bg-[#0F172A]/85 px-5 py-4 backdrop-blur-xl">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">Focused On</p>
              <p className="mt-1 text-sm font-semibold text-slate-100">Secure Processing · Transparent Rates</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-7">
          <ChapterTag index="05" label="Trust & Security" />
          <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tighter text-slate-50 sm:text-5xl">
            An Exchange Experience <span className="text-[#00F5A0]">You Can Trust</span>
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-400 sm:text-lg">
            Coin Adda focuses on what matters: secure transaction processing,
            transparent rates and a simple exchange experience — from your USDT
            deposit to your INR payout.
          </p>

          <ul className="mt-8 space-y-4" data-testid="trust-points">
            {POINTS.map((point) => (
              <li key={point} className="flex items-start gap-3">
                <CheckCircle size={22} weight="duotone" className="mt-0.5 shrink-0 text-[#00F5A0]" />
                <span className="text-sm leading-relaxed text-slate-300 sm:text-base">{point}</span>
              </li>
            ))}
          </ul>

          <p className="mt-8 max-w-lg font-mono text-xs leading-relaxed text-slate-500" data-testid="trust-disclaimer">
            Cryptocurrency values fluctuate. The rate shown in the app at the
            time of your exchange applies to your transaction.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
